/* global document */

import AppContext from './context/AppContext';
import React, { useCallback, useContext, useMemo } from 'react';
import '../styles/ContactUsHeader.css';
import constants from '../constants.json' assert { type: 'json' };
import PropTypes from 'prop-types';

const ContactUsHeader = ({ useExpandedForm }) => {
    const { appContext } = useContext(AppContext);

    const phoneNumber = useMemo(
        () => appContext.config.contactPhoneNumber,
        [appContext.config.contactPhoneNumber],
    );

    const handleClick = useCallback(() => {
        const {
            FORM_IFRAME_ID,
            BUTTON_IFRAME_ID,
            INPUT_SELECTOR,
            TEXTAREA_SELECTOR,
            BUTTON_SELECTOR,
        } = constants.ZENDESK;

        const zendeskFormIframe = document.querySelector(FORM_IFRAME_ID);
        const zendeskButtonIframe = document.querySelector(BUTTON_IFRAME_ID);

        if (zendeskFormIframe) {
            const inputs = zendeskFormIframe.contentDocument.querySelectorAll(`${INPUT_SELECTOR}, ${TEXTAREA_SELECTOR}`);
            for (const input of inputs) {
                if (!input.value) {
                    input.focus();
                    break;
                }
            }
        } else if (zendeskButtonIframe) {
            const zendeskButton = zendeskButtonIframe.contentDocument.querySelector(BUTTON_SELECTOR);
            const messageInput = zendeskButtonIframe.contentDocument.querySelector(INPUT_SELECTOR);

            if (messageInput) {
                messageInput.focus();
            } else if (zendeskButton) {
                zendeskButton.click();
            }
        }
    }, []);

    return (
        <div
            style={{
                width: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
            className={'d-flex flex-column align-items-center'}>
            <div
                className={'contact-us-header'}>
                {useExpandedForm ? <span
                    className={''}>You may contact us at </span> : ''}
                <a
                    className={'custom-link'}
                    href={`tel:${phoneNumber}`}
                    style={{
                        fontStyle: 'italic',
                        fontWeight: '700',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {phoneNumber}
                </a>
                <span
                    className={'contact-us-header--text'}>or</span>
                <button
                    onClick={handleClick}
                    className={'contact-us-header--button'}
                >
                    Chat Now
                </button>
                {!useExpandedForm && (
                    <>
                        <span
                            className={'contact-us-header--text'}
                        >
                            •
                        </span>
                        <span
                            style={{
                                whiteSpace: 'nowrap',
                                fontSize: '0.9em',
                            }}
                        >
                            Mon-Fri 6am-5pm PST
                        </span>
                    </>
                )}
            </div>
            {useExpandedForm && (
                <div
                    style={{
                        whiteSpace: 'nowrap',
                    }}>
                    <span>
                        Mon-Fri 6AM-8PM PST and Sat-Sun 6AM-3PM PST
                    </span>
                </div>
            )}
        </div>
    );
};

ContactUsHeader.propTypes = {
    useExpandedForm: PropTypes.bool,
};

export default ContactUsHeader;